import React, { useState } from "react";

export default function ContactsGrid({
  initialNames = Array(30).fill(""),
  initialPhones = Array(30).fill(""),
  onSave,
  onClear,
}) {
  const [names, setNames] = useState(initialNames);
  const [phones, setPhones] = useState(initialPhones);

  function setNameAt(index, value) {
    setNames((prev) => {
      const next = prev.slice();
      next[index] = value;
      return next;
    });
  }

  function setPhoneAt(index, value) {
    setPhones((prev) => {
      const next = prev.slice();
      next[index] = value;
      return next;
    });
  }

  function clearAll() {
    const clearedNames = Array(30).fill("");
    const clearedPhones = Array(30).fill("");
    setNames(clearedNames);
    setPhones(clearedPhones);
    if (onClear) onClear(clearedNames, clearedPhones);
  }

  return (
    <div>
      <h3>Contacts (30 names + 30 phones)</h3>
      <div>
        {Array.from({ length: 30 }).map((_, i) => (
          <div key={i}>
            <label style={{ fontSize: "25px" }}>
              <b>Ramadan # {i + 1}---</b> Name:{" "}
            </label>
            <input
              value={names[i]}
              onChange={(e) => setNameAt(i, e.target.value)}
            />
            <label style={{ fontSize: "25px" }}> Phone: </label>
            <input
              value={phones[i]}
              onChange={(e) => setPhoneAt(i, e.target.value)}
            />
          </div>
        ))}
      </div>
      <div>
        <button
          style={{
            margin: "20px",
            // marginLeft: "10px",
            // marginRight: "10px",
            padding: "10px 20px",
            fontSize: "16px",
            borderRadius: "5px",
            border: "none",
            backgroundColor: "#48e10bff",
            color: "white",
            cursor: "pointer",
          }}
          onClick={() => onSave && onSave(names, phones)}
        >
          Save
        </button>
        <button
          style={{
            marginLeft: "550px",
            marginBottom: "20px",
            padding: "10px 20px",
            fontSize: "16px",
            borderRadius: "5px",
            border: "none",
            backgroundColor: "#a93232ff",
            color: "white",
            cursor: "pointer",
          }}
          onClick={clearAll}
        >
          Clear
        </button>
      </div>
    </div>
  );
}
